<template lang="pug">
	div(class="kt-decisions")
		div(class="decs-header")
			div(class="decs-date")
				span Decision Date
				div
					b-form-select(:options="c_selDecsDates" v-model="d_decsIdCurr" plain @change="m_chgDecs")
				span(:class="d_decs.isGo == 1?'isGo' : d_decs.isGo == 0?'isNoGo': 'undec'")
					fa-icon(icon="dot-circle")
			div(class="small")
				b-button(class="btn-refresh" title="Refresh" variant="outline-secondary" @click="m_refreshClick")
					fa-icon(icon="sync")
		div(class="decs-content")
			//- Loading
			kt-spinner(v-if="d_loading" p_txt="Decision")
			table(v-show="!d_loading")
				thead
					th Bid Factor
					th(class="weight") Weight
					th(class="score") Score
					th(class="cmnt") Comments
					
				tbody
					tr(v-for="(s,ix) in d_scores" :key="ix" class="qstn")
						td {{m_questTxt(s.decisionQuestionId)}}
						td 
							b-form-select(:options="d_weights" v-model="s.weight" plain)
						td
							//- input(type="number" min=0 max=10 v-model="s.score")
							b-form-select(:options="c_selScores" v-model="s.score" plain)
						td
							b-form-input(type="text" v-model="s.comments" maxlength=500)
				tfoot
					tr(class="score")
						td(colspan=3)
							div
								span Max score:
								span {{c_maxScore}}
							div(class="font-weight-bold")
								span Total score:
								span {{d_decs.totalScore}}
						td(rowspan=4)
							b-form-textarea(v-model="d_decs.comments" rows=5 maxlength=1000 placeholder='Additional Decision Comments')
					tr(class="pct")
						td(colspan=3) 
							div
								span Minimum % of max score for "Go":
								span {{d_decs.minPctOfMaxForGo}}%
							div
								span % of Max score:
								span  {{c_pctOfMax}}%
					tr(class="decision")
						td(colspan=3) 
							div
								span Decision: 
								b-form-radio-group(stacked v-model="d_decs.isGo" )
									b-form-radio(name="go-nogo" value=1 button-variant="outline-success") Go
									b-form-radio(name="go-nogo" value=0 button-variant="outline-danger") No Go
									b-form-radio(name="go-nogo" value=-1 button-variant="outline-secondary") Undecided
					tr
						td(colspan=3) 

		div(class="decs-footer" v-show="!d_loading")
			div
				b-button(class="btn-save" title="Save" variant="primary" @click="m_save") Save
			div(v-if="d_decsIdCurr!='new'" class="info")
				span Created on {{d_util.fn_fmtDtmStr(d_decs.createdUTC,true)}} by {{d_decs.createdBy}}
				span(v-if="d_decs.updatedUTC") Last updated on {{d_util.fn_fmtDtmStr(d_decs.updatedUTC,true)}} by {{d_decs.updatedBy}}

</template>

<script>

import {fn_getDecisions, fn_saveDecision} from "@/utils/api.js";
import util, {kbdpAlert} from "@/utils/util.js";
import {tenantSettings, refData} from "@/utils/ref-data.js";

export default {
	name: "kt-decisions",
	components: {},
	created() {
		fn_getData(this);
	},
	data() {
		return {
			d_util: util,
			d_resp: {
				decisions: [],
				decisionScores: [],
			},

			d_decs: fn_decs(),
			d_scores: fn_decsScores(),
			d_decsIdCurr: 'new',
			d_weights: refData.decisionWeights,

			d_loading: null,
		};
	},
	props: {
		p_recInfo: Object,
	},
	computed: {
		c_selDecsDates() {
			let d = this.d_resp.decisions.map(d => ({
				value: d.decisionId,
				text: util.fn_fmtDtmStr(d.createdUTC, true),
			}));
			return [...d, {value: 'new', text: 'Create New'}];
		},
		c_selScores() {
			let s = [];
			for (let i = 1; i <= 10; i++) {
				s.push({text: i, value: i});
			}
			return s;
		},
		c_totalScore() {
			let d = this.d_scores.map(x => x.score * x.weight);
			return Math.round(util.fn_calcSum(d, false) * 1000) / 1000;
		},
		c_maxScore() {
			let d = this.d_scores.map(x => 10 * x.weight);
			return util.fn_calcSum(d, false);
		},
		c_pctOfMax() {
			return Math.round(this.c_totalScore * 1000 / this.c_maxScore) / 10;
		},
		c_isGo() {
			return this.c_pctOfMax >= this.d_decs.minPctOfMaxForGo;
		}
	},
	methods: {
		m_questTxt(questId) {
			return refData.decisionQuestions.filter(x => x.id == questId)[0].quest;
		},
		m_save() {
			fn_saveData(this);
		},
		m_refreshClick() {
			fn_getData(this);
		},
		m_chgDecs() {
			fn_setDecisionData(this);
		}
	},
	watch: {
		c_isGo(nv) {
			this.d_decs.isGo = nv ? 1 : 0;
		},
		c_totalScore(nv) {
			this.d_decs.totalScore = nv;
		}
	}
};

function fn_decs() {
	return {
		decisionId: null,
		minPctOfMaxForGo: tenantSettings.decisionOptions.minPctOfMaxForGo || 75,
		totalScore: null,
		isGo: -1,
		comments: null,

		createdUTC: null,
		createdBy: null,
		updatedUTC: null,
		updatedBy: null,
	};
}

function fn_decsScores() {
	let dq = refData.decisionQuestions.filter(x => !x.disabled);

	return dq.map(q => ({
		decisionScoreId: null,
		decisionQuestionId: q.id,
		weight: q.dfltWght,
		score: null,
		comments: null
	}));
}
function fn_getData(vc) {
	vc.d_loading = true;
	fn_getDecisions(vc.p_recInfo.Id).then(resp => {
		vc.d_loading = null;
		if (resp.error || resp.errorMessage) {
			let msg = `Unable to load Decision ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}

		let decs = resp.decisions;
		let decsScr = resp.decisionScores;

		vc.d_resp.decisions = decs || [];
		vc.d_resp.decisionScores = decsScr || [];

		if (!decs) return;

		decs.forEach(x => x.isGo = (x.isGo === true ? 1 : x.isGo === false ? 0 : -1));

		vc.d_decsIdCurr = decs[0].decisionId;
		fn_setDecisionData(vc);
	});
}
function fn_saveData(vc) {
	kbdpAlert.showSaving('Decision');
	let decsData = {
		decision: vc.d_decs,
		decisionScores: vc.d_scores,
	};

	fn_saveDecision(vc.p_recInfo.Id, decsData).then(resp => {
		if (resp.error || !resp.upsRecHdr) {
			let msg = `Unable to save Decision ` + (resp.error || "");
			kbdpAlert.showErr(msg);
			return;
		}
		else {
			kbdpAlert.clear();
		}
		let decs = resp.upsRecHdr.decision;
		let decsScr = resp.upsRecHdr.decisionScores;

		Object.keys(decs).forEach(k => {
			vc.d_decs[k] = decs[k];
		});

		util.fn_spliceById(vc.d_resp.decisions, 'decisionId', vc.d_decs.decisionId, vc.d_decs);

		decsScr.forEach(ds => {
			let vcds = vc.d_scores.filter(x => x.decisionQuestionId == ds.decisionQuestionId)[0];
			if (vcds) {
				vcds.decisionScoreId = ds.decisionScoreId;
				util.fn_spliceById(vc.d_resp.decisionScores, 'decisionScoreId', ds.decisionScoreId, vcds);
			}
		});

		vc.d_decsIdCurr = vc.d_decs.decisionId;
		kbdpAlert.showOk('The Decision was saved successfully');
	});
}

function fn_setDecisionData(vc) {
	let decsId = vc.d_decsIdCurr;

	if (decsId == 'new') {
		vc.d_decs = fn_decs();
		vc.d_scores = fn_decsScores();
		return;
	}
	else {
		vc.d_scores.length = 0;
	}
	let decs = vc.d_resp.decisions.filter(d => d.decisionId == decsId)[0];
	Object.keys(vc.d_decs).forEach(k => {
		let dVal = decs[k];
		if (dVal == null || dVal == undefined) return;
		vc.d_decs[k] = dVal;
	});

	vc.d_resp.decisionScores.filter(ds => ds.decisionId == decsId).forEach(ds => {
		vc.d_scores.push(ds);
	});
}

</script>

<style lang="less">
div.kt-decisions {
	div.decs-header {
		display: flex;
		padding: 0.4em 0;
		margin-bottom: 0.2em;
		// border-bottom: solid 0.1em #adb5bd;

		div.decs-date {
			font-size: 0.9em;
			display: flex;
			flex-grow: 1;

			> span:first-child {
				padding-right: 0.5em;
			}
			> div {
				padding-right: 0.5em;
				select {
					font-size: 0.9em;
					padding: 0.2em 0em;
					width: 175px;
				}
			}

			span.isGo,
			span.isNoGo {
				margin: auto 0;
				&.isGo {
					color: #28a745;
					&::after {
						content: "Go";
					}
				}
				&.isNoGo {
					color: #dc3545;
					&::after {
						content: "No Go";
					}
				}

				&::after {
					color: initial;
					padding-left: 0.3em;
				}
			}
			span.undec {
				display: none;
			}
		}

		.btn-refresh {
			font-size: 1em;
			margin-right: 0.3em;
			padding: 0em 0.3em;
		}
	}
	div.decs-content {
		overflow-x: auto;
		table {
			font-size: 0.9em;
			text-align: left;
			width: 100%;
			min-width: 500px;
			thead th {
				border-bottom: solid 0.2em #adb5bd;

				&.weight {
					width: 70px;
				}
				&.score {
					width: 90px;
				}
				&.cmnt {
					width: 35%;
				}
			}
			tbody {
				tr {
					border-bottom: solid 0.1em #adb5bd;
					&:hover {
						background-color: #f8f9fa;
					}
				}
				tr td {
					padding: 0.4em 0.2em;
					> select {
						font-size: 0.95em;
						max-width: 55px;
						height: 25px;
					}
					> input[type="text"] {
						font-size: 0.95em;
					}
				}
			}
			tfoot {
				border-bottom: solid 0.2em #adb5bd;
				tr td {
					padding: 0.2em 0;
				}
				tr > td > div {
					// border: solid 0.1em red;
					padding-right: 2em;
					display: inline-block;
					min-width: 200px;
					> span:first-child {
						padding-right: 0.5em;
					}
					> span:last-child {
						display: inline-block;
						text-align: left;
						width: 55px;
					}
				}
				tr.score,
				tr.pct,
				tr.decision {
					height: 20px;
					td:first-child {
						text-align: right;
					}
				}

				tr.decision td > div {
					display: inline-flex;
					padding-top: 0.5em;
					padding-bottom: 0.5em;

					> span {
						margin: auto 0;
						margin-left: auto;
					}
					> div {
						text-align: left;
						label {
							line-height: 1.7em;
						}

						> .custom-radio {
							&:nth-child(1) {
								.custom-control-input:checked ~ label::before {
									border-color: #28a745;
									background-color: #28a745;
								}
							}
							&:nth-child(2) {
								.custom-control-input:checked ~ label::before {
									border-color: #dc3545;
									background-color: #dc3545;
								}
							}
							&:nth-child(3) {
								.custom-control-input:checked ~ label::before {
									border-color: #adb5bd;
									background-color: #adb5bd;
								}
							}
						}
					}
				}

				tr td textarea {
					font-size: 0.95em;
					margin: 0.5em 0;
					resize: vertical;
					min-height: 100px;
					max-height: 400px;
				}
			}
		}
	}
	div.decs-footer {
		padding-top: 0.5em;
		display: flex;

		> div:first-child {
			text-align: left;
			.btn-save {
				padding: 0.1em 0.4em;
			}
		}
		div.info {
			padding: 0 0.5em;
			margin: auto 0;
			font-size: 0.8em;
			flex-grow: 1;
			>span{
				display: block;
			}
		}
	}
}
</style>